import React from 'react';
import PropTypes from 'prop-types';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import withContent from '../../../containers/withContent';
import TooManyFavouritesContent, { contentPropTypes } from './TooManyFavouritesErrorModal.content';

export const TooManyFavouritesErrorModal = ({ content, showTooManyFavouritesModal, onClose }) => {
	const buttons = [
		<Button display="primary" onClick={onClose} size="sm">
			{content.okButtonLabel}
		</Button>,
	];
	return (
		<MultiButtonModal isOpen={showTooManyFavouritesModal} onClose={onClose} titleText={content.title} buttons={buttons}>
			<StandardBody>
				<p>{content.body}</p>
			</StandardBody>
		</MultiButtonModal>
	);
};

TooManyFavouritesErrorModal.propTypes = {
	showTooManyFavouritesModal: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	content: PropTypes.shape({ contentPropTypes }).isRequired,
};
export default withContent({ content: TooManyFavouritesContent })(TooManyFavouritesErrorModal);
